const STORAGE_KEY = "metricas.filters";

export const loadFilterSection = (section) => {
    if (typeof window === "undefined") return null;

    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== "object") return null;
        return parsed[section] || null;
    } catch (error) {
        return null;
    }
};

export const saveFilterSection = (section, value) => {
    if (typeof window === "undefined") return;

    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        const next = {
            ...(parsed && typeof parsed === "object" ? parsed : {}),
            [section]: value,
        };
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
        // Ignore storage errors (private mode, quota, etc.).
    }
};

export const clearFilterStorage = () => {
    if (typeof window === "undefined") return;

    try {
        window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        // Ignore storage errors (private mode, quota, etc.).
    }
};
